import type { ComponentProps } from 'react';

import type { Breadcrumbs } from '@change/ds-core-ui/next';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useTopicPageData } from 'src/app/pages/topic/pageContext';

type Result = ModelHookResult<{
	items: ComponentProps<typeof Breadcrumbs>['items'];
}>;

export function useTopicBreadcrumbs(): Result {
	const {
		data: { name },
	} = useTopicPageData();
	const { translate } = useI18n();

	return {
		data: {
			items: [
				{ label: translate('corgi.topic_page.breadcrumbs.home'), href: '/' },
				{ label: translate('corgi.topic_page.breadcrumbs.topic'), href: '/topic?source_location=topic-breadcrumb' },
				{ label: name },
			],
		},
	};
}
